import {Injectable} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {GlobalMessageService} from '@spartacus/core';
import {UpdateProfileComponentService} from '@spartacus/user/profile/components';
import {UserProfileFacade} from '@spartacus/user/profile/root';

import {AimoUser} from '../../../../model/user.model';
import {AimoCustomFormValidators} from '../../../../shared/validators/aimo-custom-form-validators';
import {AimoProductSearchService} from "../../../../service/product/search/aimo-product-search.service";

@Injectable({providedIn: 'root'})
export class AimoUpdateProfileComponentService extends UpdateProfileComponentService {
    constructor(
        protected userProfile: UserProfileFacade,
        protected globalMessageService: GlobalMessageService,
        protected productSearchService: AimoProductSearchService
    ) {
        super(userProfile, globalMessageService);
    }

    initForm(user: AimoUser): FormGroup {
        const controls = {
            name: new FormControl(user.name, Validators.required),
            email: new FormControl(user.email, [Validators.required, AimoCustomFormValidators.emailValidator]),
            phone: new FormControl(user.phone, [Validators.required, AimoCustomFormValidators.phoneNumberValidator]),
            uid: new FormControl(user.uid),
            password: new FormControl(''),
            orderConfirmationsInEmail: new FormControl(user.orderConfirmationsInEmail),
        };
        if (user.showProductPricesWithTax !== undefined) {
            controls['showProductPricesWithTax'] = new FormControl(user.showProductPricesWithTax, Validators.required);
        }
        this.form = new FormGroup(controls);
        return this.form;
    }

    updateProfile(): void {
        if (!this.form.valid) {
            this.form.markAllAsTouched();
            return;
        }

        this.busy$.next(true);
        const formValue = {
            ...this.form.value,
            showProductPricesWithTax: this.form.value.showProductPricesWithTax
        };
        this.userProfile.update(formValue).subscribe({
            next: () => this.onSuccess(),
            error: (error: Error) => this.onError(error),
        });
    }

    onSuccess(): void {
        super.onSuccess();
        this.productSearchService.clearResults();
    }
}
